/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticleCategoryDTO } from './article-category-dto';
import { DossierDto } from './dossier-dto';
import { MixtureCategoryDTO } from './mixture-category-dto';
import { SubstanceDTO } from './substance-dto';
import { MaterialCategoryDTO } from './material-category-dto';
import { OtherArticleNamesDto } from './other-article-names-dto';
import { ResourceSuiMapDTO } from './resource-sui-map-dto';
import { OtherArticleIdentifierDto } from './other-article-identifier-dto';


/**
 * Representation of a product details response sent by SCIP server to UI.
 */
export interface ProductNodeDto { 
    productType?: ProductNodeDtoProductTypeEnum;
    name?: string;
    identifier?: string;
    appIdentifier?: string;
    marketRelevantInEu?: boolean;
    numberOfInstances?: number;
    primaryArticleIdentifierType?: string;
    primaryArticleIdentifierValue?: string;
    otherArticleIdentifiersChanged?: boolean;
    otherArticleIdentifiers?: Array<OtherArticleIdentifierDto>;
    otherArticleNamesChanged?: boolean;
    otherArticleNames?: Array<OtherArticleNamesDto>;
    articleCategoriesChanged?: boolean;
    articleCategories?: Array<ArticleCategoryDTO>;
    vdaMaterialCategories?: Array<MaterialCategoryDTO>;
    vdaMixtureCategories?: Array<MixtureCategoryDTO>;
    materialCategoriesChanged?: boolean;
    materialCategories?: Array<MaterialCategoryDTO>;
    otherMatCatText?: string;
    mixtureCategoriesChanged?: boolean;
    mixtureCategories?: Array<MixtureCategoryDTO>;
    productionInEU?: ProductNodeDtoProductionInEUEnum;
    customSUIText?: string;
    provideSafeUseInstruction?: boolean;
    suiBlankValue?: string;
    suiAlwaysValue?: string;
    substances?: Array<SubstanceDTO>;
    echaSvhcRelevance?: ProductNodeDtoEchaSvhcRelevanceEnum;
    resourceSuiMaps?: Array<ResourceSuiMapDTO>;
    dossier?: DossierDto;
    posNo?: number;
    orderId?: number;
    dummyNode?: boolean;
    imdsScipNumber?: string;
    imdsScipSubmissionNumber?: string;
    isValidImdsScipNumber?: boolean;
    useImdsScipNumber?: boolean;
    forceResubmission?: boolean;
}
export enum ProductNodeDtoProductTypeEnum {
    Article = 'ARTICLE',
    Component = 'COMPONENT',
    Semicomponent = 'SEMICOMPONENT',
    Mixture = 'MIXTURE',
    HomogeneousMaterial = 'HOMOGENEOUS_MATERIAL',
    Material = 'MATERIAL',
    Substance = 'SUBSTANCE'
};
export enum ProductNodeDtoProductionInEUEnum {
    EuProduced = 'EU_PRODUCED',
    EuImported = 'EU_IMPORTED',
    EuProducedAndImported = 'EU_PRODUCED_AND_IMPORTED',
    NoData = 'NO_DATA'
};
export enum ProductNodeDtoEchaSvhcRelevanceEnum {
    NoCalculation = 'NO_CALCULATION',
    NotYetCalculated = 'NOT_YET_CALCULATED',
    No = 'NO',
    Yes = 'YES',
    NotAnyLonger = 'NOT_ANY_LONGER'
};



